import { Tab, Modal, Collapse } from 'bootstrap'; 
import {initLayout} from '../layout.js';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import {initWhereWeAreFrom} from '../components/sections/where-we-are-from.js';
import gsap from 'gsap';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);


window.addEventListener("load", function(){
	let sectionID=getSectionId()
    activeCurrentSection(sectionID);
	if(sectionID=='cultivation'){
		scrollToSection('#cultivation')
	}
	if(sectionID=='quality-control'){
		scrollToSection('#quality-control')
	}
	if(sectionID=='sustainability-practice'){
		scrollToSection('#sustainability-practice')
	}
});

initWhereWeAreFrom();

let siteUrl = window.location.href;
initLayout();

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".custom-youtube-wrapper").forEach(function(wrapper) {
        wrapper.addEventListener("click", function() {
        var videoId = this.getAttribute("data-video-id");
        var iframe = document.createElement("iframe");
        iframe.setAttribute("src", "https://www.youtube.com/embed/" + videoId + "?autoplay=1");
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "1");
        iframe.setAttribute("allow", "autoplay");

        this.innerHTML = "";
        this.appendChild(iframe);
        });
    });
});

let swiper = new Swiper(".mySwiper", {
    slidesPerView: 1.2,
    spaceBetween: 10,
    centeredSlides: true,
    loop: true,
    pagination: {
        el: ".production-overview .swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".production-overview .swiper-button-next",
        prevEl: ".production-overview .swiper-button-prev",
    },

    breakpoints: {
        768: {
            slidesPerView: 2.5,
            spaceBetween: 20,
        },
        1200: {
            slidesPerView: 2.3,
            spaceBetween: 30,
        },
    },
});

var qualityControlSwiper = new Swiper(".qualityControlSwiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    pagination: {
        el: ".quality-control .swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".quality-control .swiper-button-next",
        prevEl: ".quality-control .swiper-button-prev",
    },
    breakpoints: {
        768: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        1200: {
            slidesPerView: 1.5,
            spaceBetween: 30,
        },
    },
});

function getSectionId(){
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });
    let value = params.section; 
    return value;
}

function scrollToSection(target, offset = 100) {
    const targetElement = document.querySelector(target);
    if (targetElement) {
        const targetPosition = targetElement.offsetTop - offset;

        gsap.to(window, {
            duration: 0.5,
            scrollTo: targetPosition
        });
    }
}

function activeCurrentSection(currentSection){

    const links = document.querySelectorAll('.navbar__menu-link');

    // Filter links that include "section=vision" in the href

    const matchingLinks = Array.from(links).filter(link => {
        const url = new URL(link.href, window.location.origin);
        link.classList.remove('active');
        if(url.searchParams.get('section') === currentSection){
            link.classList.add('active');
        }else{
            link.classList.remove('active');
        }
    });
}

